import { Typography, Box, CircularProgress, css } from '@mui/material';
import queryString from 'query-string';
import { Fragment, useMemo } from 'react';

import { useGetTextForViewer } from '../api/useTextViewer';
import { useSessionStore } from 'session/useSessionStore';

const containerStyle = css({
    width: '100vw',
    height: '100vh',
    '& .text-loading': {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '& .text-content': {
        width: '100%',
        height: '100%',
        overflowX: 'auto',
        overflowY: 'auto',
        '& .text-body': {
            whiteSpace: 'pre',
        },
    },
});

export function TextViewer() {
    const queryParams = queryString.parse(window.location.search);

    const { tenantConfig } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration
    }));

    const url = useMemo(() => {
        if (typeof queryParams.fileToken !== 'string') {
            return undefined;
        }
        if (queryParams.source === 'file-manager') {
            return `${tenantConfig?.endpoints.fileManager}/filemanager/filemanager/downloadFile?&fileToken=${queryParams.fileToken}`;
        }
        if (queryParams.source === 'file-indexing') {
            return `${tenantConfig?.endpoints.fileManager}/FileManager/FileManager/GetFileForViewer?fileToken=${queryParams.fileToken}`;
        }
        return undefined;
    }, [tenantConfig, queryParams.source, queryParams.fileToken]);

    const { data, isLoading } = useGetTextForViewer(url);

    return (
        <Box css={containerStyle}>
            {isLoading ?
                (<Box className="text-loading">
                    <CircularProgress />
                </Box>) :
                (<Box className="text-content">
                    <Typography className="text-body">
                        {data}
                    </Typography>
                </Box>)
            }
        </Box>
    );
}
